import styled from 'styled-components'

import { _S_Normal, semanticColors } from '@avantstay/backoffice-core'

import { EmptySearch } from '@new/__global/components/EmptySearch'

export const CleanMarker = styled.div`
  ${_S_Normal};
  color: ${semanticColors.successDark};
  background: ${semanticColors.successExtraLight};
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 16px;
`

export const CleanMarkerLate = styled(CleanMarker)`
  color: ${semanticColors.warningExtraDark};
  background: ${semanticColors.warningExtraLight};
`

export const Messages = styled.div<{ $isUpdating?: boolean }>`
  opacity: ${({ $isUpdating }) => ($isUpdating ? 0.5 : 1)};
  transition: opacity 150ms ease;
`

export const FilteredEmpty = styled(EmptySearch)`
  && {
    min-height: auto;
    margin: 0;
    padding: 32px 0;
    background-color: transparent;
  }
`
